import { BaseContainerModel } from '../../base-container.model';
import {
  bl_dgmkt_campaign_message_link_RowClass,
  bl_dgmkt_campaign_message_link_RowInterface,
} from '../../../dbschema/bl_dgmkt_campaign_message_link.model';

export class DgMktCampaignMessageContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_message_link: bl_dgmkt_campaign_message_link_RowInterface =
    new bl_dgmkt_campaign_message_link_RowClass();
}
